<template>
  <v-layout>
    <v-dialog v-model="dialog" scrollable max-width="640px">
      <v-card>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          SurfAndScan Treiber nicht gefunden.
        </v-card-text>
        <v-card-text>

          <v-layout class="justify-center" row wrap >
            <v-flex xs12 class="text-left pl-4">
              Bitte installieren Sie den SurfAndScan Treiber.
            </v-flex>
          </v-layout>
          <v-layout class="justify-center" row wrap>
            <v-flex xs3 class="mt-1 handpointer">
              <v-card @click="download()" style="height:200px">
                <v-card-text>
                  1. Downloaden<br><br>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs3 class="pa-1">
              <v-card  style="height:200px">
                <v-card-text>
                  2. Installieren<br><br>
                  Entpacken Sie die Zip Datei und installieren sie den Treiber.
                </v-card-text>
              </v-card>

            </v-flex>
            <v-flex xs3 class="pa-1">
            <v-card style="height:200px" class="justify-center">
              <v-card-text>
                3. Scannen<br><br>
                Nun können Sie scannen
              </v-card-text>
            </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-btn class="text-none" color="black" outline flat @click="dialog = false">abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="examenis" outline flat @click="closeDialog">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'DialogMissingSASDriver',
  data () {
    return {
      dialog: false,
      cellData: {}
    }
  },
  methods: {
    download: function () {
      window.open('https://surfandscan.de/download/SurfAndScanInstaller.zip', '_new')
    },
    closeDialog: function () {
      this.dialog = false
      var that = this
      that.cellData.config = JSON.stringify(this.config)
      this.$emit('onSave', {
        item: that.cellData,
        extraFields: that.tableItems,
        categorySelectWord: that.categorySelectWord
      })
    },
    open: function (item) {
      console.log('item', item)
      this.cellData = item
      this.dialog = true
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogMissingSASDriver.vue